import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
const DefaultContainerContext = {
    showHeader: true,
    showFooter: false,
    showUtilityNav: true,
    isFullscreen: false,
    setShowHeader: () => { },
    setShowFooter: () => { },
    setShowUtilityNav: () => { },
    setIsFullscreen: () => { },
};
export const ContainerContext = createContext(DefaultContainerContext);
export const ContainerContextProvider = ({ children }) => {
    const [showHeader, setShowHeader] = useState(DefaultContainerContext.showHeader);
    const [showFooter, setShowFooter] = useState(DefaultContainerContext.showFooter);
    const [showUtilityNav, setShowUtilityNav] = useState(DefaultContainerContext.showUtilityNav);
    const [isFullscreen, setIsFullscreen] = useState(DefaultContainerContext.isFullscreen);
    const value = {
        ...DefaultContainerContext,
        showHeader,
        showFooter,
        showUtilityNav,
        isFullscreen,
        setShowHeader,
        setShowFooter,
        setShowUtilityNav,
        setIsFullscreen,
    };
    return _jsx(ContainerContext.Provider, { value: value, children: children });
};
